// 接口默认的参数
const data = {
    defaultData: { // 接口默认的参数
        source: 'h5',
        user_id: '',
        session_id: '',
        token: '',
        ck_prefix: '', //cookie的前缀
        ck_path: '',
        ck_domain: '',
        is_wechat: 0, //是否为微信环境
        is_wx_auth: 0, //是否刚刚授权
        is_login: 0, //是否登录
        is_mob_vl: '', //是否有手机号，本项目废弃
        oauth_url: '', //授权地址
        inviteuid: '', //邀请人ID，本项目废弃
        is_bind: '', //是否绑定，本项目废弃
        is_wx_rela: 0, //是否已经关联微信记录
        callback_url: encodeURIComponent(window.location.href),
    },
    previewData: { // 图片预览的参数
        maxSpreadZoom: 4, // 控制预览图最大的倍数，默认是2倍，我这里改成了原图
        fullscreenEl: false, //控制是否显示右上角全屏按钮
        closeEl: false, //控制是否显示右上角关闭按钮
        tapToClose: true, //点击滑动区域应关闭图库
        shareEl: false, //控制是否显示分享按钮
        zoomEl: true, //控制是否显示放大缩小按钮
        counterEl: false, //控制是否显示左上角图片数量按钮
        arrowEl: false,  //控制如图的左右箭头（pc浏览器模拟手机时）
        tapToToggleControls: true, //点击应切换控件的可见性
        clickToCloseNonZoomable: true //点击图片应关闭图库，仅当图像小于视口的大小时
    },
    vueLazyLoadOption: { // 图片懒加载的参数
        preLoad: 1,
        error: require('../assets/images/case_detail_def.png'),
        loading: require('../assets/images/case_detail_def.png'),
        attempt: 10,
    },
    //高德地图key和使用的插件、安全密钥
    AMapData: {
        key: 'c4489c97ef3ee372a0d09bfce1a8a3b6',
        plugin: ['AMap.Geolocation'],
        securityJsCode: '68845aa88e5e8992e06132a3f9281a0f'
    },
    //vue忽略该跳转的组件标签
    ignoredElements: ["wx-open-launch-weapp"],
    weChat: {
        wx: 1,
        wxWork: 6,
        h5: 0
    }
}

export default data;
